'use client'

import { Builder } from '@builder.io/react'

import { CustomerReviewsDefaults } from '@src/components/CustomerReviews/CustomerReviews.defaults'

import { CustomerReviews } from './CustomerReviews'

Builder.registerComponent(CustomerReviews, {
  name: 'CustomerReviewsGrid',
  inputs: [
    {
      name: 'accentColor',
      type: 'color',
      defaultValue: CustomerReviewsDefaults.accentColor,
    },
    {
      name: 'gradientColor',
      type: 'color',
      defaultValue: CustomerReviewsDefaults.gradientColor,
    },
    {
      name: 'heading',
      type: 'text',
      defaultValue: CustomerReviewsDefaults.heading,
    },
    {
      name: 'subheading',
      type: 'html',
      defaultValue: CustomerReviewsDefaults.subheading,
    },
    {
      name: 'subHeadingRatingOutOfFive',
      type: 'number',
      defaultValue: CustomerReviewsDefaults.subHeadingRatingOutOfFive,
    },
    {
      name: 'loadMoreText',
      type: 'text',
      defaultValue: CustomerReviewsDefaults.loadMoreText,
    },
    {
      name: 'blocksBottom',
      type: 'blocks',
      hideFromUI: true,
      defaultValue: CustomerReviewsDefaults.blocksBottom,
    },
    {
      name: 'items',
      type: 'list',
      defaultValue: CustomerReviewsDefaults.items,
      subFields: [
        {
          name: 'name',
          type: 'text',
        },
        {
          name: 'product',
          type: 'html',
        },
        {
          name: 'ratingOutOfFive',
          type: 'number',
        },
        {
          name: 'content',
          type: 'html',
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/hand-click.svg',
})
